import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CrmOpportunityStage } from "@enums/crmOpportunityStage.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { CrmOpportunityService } from "@services/crmOpportunity.service";
import { ExportLogService } from "@services/exportLog.service";
import { LogExport } from "@interfaces/logExport.interface";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-opportunities",
	styleUrls: ["crmOpportunities.css"],
	templateUrl: "crmOpportunities.html"
})
export class CrmOpportunitiesAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "CRM Opportunity";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	stages: any[] = [];

	constructor(private router: Router, private toastService: ToastService, private itemService: CrmOpportunityService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.headerPrimaryButtons.push({ icon: "fal fa-columns", method: "pipelineView", text: "Pipeline View" });
		this.stages = GetPropertiesFromEnum(CrmOpportunityStage);
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	checkGridExportPermissions() {
		this.protectedGridService.canExport("CrmOpportunities")
			.subscribe(
				(res: any) => { this.canExportGrid = res.response; },
				(err) => { console.log(err); }
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this opportunity?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => { this.toastService.success("Opportunity deleted!"); this.getItems(); },
					(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => { this.items = res.response.items; this.gridLoading = false; },
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "CrmOpportunities";
		this.exportLogService.logExport(logExport).subscribe();
	}

	pipelineView() {
		this.router.navigate([`${this.itemUrl}/pipeline`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}
